<template>
    <div class="ma-4">
        <v-snackbar v-model="msg" top>
            {{ text }}
            <v-btn color="pink" text @click="msg = false">Close</v-btn>
        </v-snackbar>

        <ClientNav />

        <v-row dense>
            <v-col cols="12" md="3" lg="3" xl="2">
                <ClientSide />
            </v-col>
            <v-col cols="12" md="9" lg="9" xl="10">
                <v-card class="pa-2" tile height="100%">
                    <v-tabs v-model="tab">
                        <v-tabs-slider color="yellow"></v-tabs-slider>
                        <v-tab v-for="(item, index) in items" :key="index" @click="activeTab = index">
                            {{ item }}
                            <v-chip class="ml-2" color="green" text-color="white" small>
                                {{ index === 0 ? activeServiceCodes : disabledServiceCodes }}
                            </v-chip>
                        </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tab">
                        <v-tab-item v-for="(item, i) in items" :key="item">
                            <v-data-table
                                :headers="headers"
                                :items="i === 0 ? serviceCodes : disabled"
                                sort-by="StartDate"
                                sort-desc
                                :loading="isLoading"
                                loading-text="Loading Client's Service Codes"
                                :search="search"
                                height="auto"
                            >
                                <template v-slot:top>
                                    <v-toolbar flat color="white">
                                        <v-toolbar-title>Service Codes</v-toolbar-title>
                                        <v-divider class="mx-4" inset vertical></v-divider>
                                        <v-spacer></v-spacer>
                                        <v-text-field
                                            v-model="search"
                                            clearable
                                            flat
                                            solo-inverted
                                            hide-details
                                            prepend-inner-icon="search"
                                            label="Search"
                                            class="flex-grow-1"
                                        ></v-text-field>
                                        <v-spacer></v-spacer>
                                        <v-btn color="#2b3990" dark @click="showAdd()">
                                            <v-icon left>add</v-icon>
                                            <span class="hidden-sm-and-down">Add Service Code</span>
                                            <span class="hidden-md-and-up">Add</span>
                                        </v-btn>
                                        <v-btn class="primary ml-3" @click="printTable()">
                                            <v-icon small>print</v-icon>
                                            <span class="hidden-sm-and-down">Print</span>
                                        </v-btn>
                                    </v-toolbar>
                                </template>

                                <template v-slot:item.actions="{ item }">
                                    <v-icon small class="mr-2 hidden-sm-and-down" @click="viewServiceCode(item)">
                                        mdi-eye
                                    </v-icon>
                                    <v-btn outlined medium class="mr-4 hidden-md-and-up" color="light-blue darken-4" @click="viewServiceCode(item)">
                                        View
                                    </v-btn>
                                    <v-icon small class="hidden-sm-and-down" @click="deleteServiceCode(item)">
                                        mdi-delete
                                    </v-icon>
                                    <v-btn medium outlined class="hidden-md-and-up red--text" @click="deleteServiceCode(item)">
                                        Delete
                                    </v-btn>
                                </template>
                                <template v-slot:no-data>
                                    <v-btn color="#2b3990" class="white--text" @click="getServiceCodes()">
                                        Reset
                                    </v-btn>
                                </template>
                            </v-data-table>
                        </v-tab-item>
                    </v-tabs-items>
                </v-card>
            </v-col>
        </v-row>
        <Foot class="hideOnPrint"/>

        <report-table
            :reportHeaderText="reportHeaderText"
            :tableHeaders="reportTableHeader"
            :tableData="reportData"
        />
    </div>
</template>

<script>
import axios from "axios";
import Foot from "@/components/Footer";
import ClientNav from "@/components/ClientNav.vue";
import ClientSide from "@/components/ClientSide.vue";
import ReportTable from '@/components/Report/ReportTable.vue';
// import DateTimeUtil from "@/../utils/date-time.util";

// import moment from 'moment'

const url = require("../../client_config/config").url;
export default {
    components: {
        Foot,
        ClientNav,
        ClientSide,
        ReportTable
    },
    data: function () {
        return {
            headers: [
                {
                    text: "Start Date",
                    align: "start",
                    value: "StartDate",
                },
                {text: "End Date", value: "EndDate"},
                {text: "Service Code", value: "ServiceCode"},
                {text: "Service Code Title", value: "Title"},
                {text: "Service Unit", value: "Units"},
                {text: "Annual Units", value: "AnnualUnits"},
                {text: "Actions", value: "actions", sortable: false},
            ],
            tab: null,
            items: ["Active Service Codes", "Disabled Service Codes"],
            msg: false,
            search: "",
            text: "",
            serviceCodes: [],
            disabled: [],
            tempData: [],
            codes: [],
            clientID: this.$route.params.clientID,
            titleForm: "New Service Code",
            units: ["Daily", "Quarter Hour", "Session"],
            serviceCodeID: "",
            newActive: "",
            isLoading: true,
            requiredRules: [(v) => !!v || "This is required"],
            activeTab: 0
        };
    },

    computed: {
        activeServiceCodes() {
            return this.serviceCodes.length;
        },
        disabledServiceCodes() {
            return this.disabled.length;
        },

        reportHeaderText() {
            return this.activeTab == 0 ? ' Active Service Codes': ' Disabled Service Codes';
        },
        reportData() {
            return this.activeTab == 0 ? this.serviceCodes : this.disabled;
        },
        reportTableHeader() {
            return this.headers.slice(0, this.headers.length-1);
        }
    },

    watch: {
        dialog(val) {
            val || this.close();
        },

        newServiceCode(val) {
            this.codes.forEach((code) => {
                if (code.Code === val) {
                    this.newUnits = code.Unit;
                    this.newTitle = code.Title;
                }
            });

            //this.newUnits = val;
        },
    },

    created() {
        this.getServiceCodes();
        this.getCodes();
    },

    methods: {
        initialize() {
            this.serviceCodes = [];
        },

        validate() {
            return this.$refs.form.validate();
        },

        viewServiceCode(item) {
            this.$router.push({
                path: `/serviceCodes/${this.clientID}/update/${item._id}`,
                query: {createNewServiceCode: false}});
        },
        showAdd() {

            this.$router.push({
                path: `/serviceCodes/${this.clientID}/new`,
                query: {newServiceCode: true}});
        },

        deleteServiceCode(item) {
            const id = item._id;
            confirm("Are you sure you want to delete this service code?") &&
            this.serviceCodeDelete(id);
        },

        serviceCodeDelete(id) {
            axios.delete(`${url}/serviceCodes/${id}`).then((response) => {
                this.getServiceCodes();
                if (response.status == 400) {
                    response.json().then(function (data) {
                        return data.msg;
                    });
                }
                this.msg = true;
                this.text = "The service has been deleted successfully.";
            });
        },


        getServiceCodes: function () {
            this.isLoading = true;
            axios
                .get(`${url}/serviceCodes/get/allClientCodes/${this.clientID}`)
                .then((res) => {
                    this.serviceCodes = res.data.activeServiceCodes;
                    this.disabled = res.data.inactiveServiceCodes;
                })
                .finally(() => (this.isLoading = false));
        },


        getCodes: function () {
            axios.get(`${url}/codes`).then((res) => {
                this.codes = res.data.codes;
            });
        },

        printTable() {
            document.getElementById('printTable').style.display = "block";
            window.print()
            document.getElementById('printTable').style.display = "none";
        }
    },
};
</script>

<style>
#printTable{
    display: none;
}

.btn-program {
    margin-top: 30px;
}

@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}
@media print {
    #printTable {
      display: block;
      border: none;
      width: 1200px;
      padding-right: 300px;
      margin-left: -200px;
    }

    .hideOnPrint {
      display: none;
      border: none;
    }

    nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
      display: none;
      border: none;

    }

    @page { margin: 0; }
    body { margin: 1.6cm; }
  }
</style>
